import React, { useContext } from 'react';
import Button from '../../Button';
import SelectCustom from '../../Select/SelectCustom';
import { ArrowNarrowRightIcon } from '../../SVGIcons/SVGIcons';
import { parseToOptions } from '../../../helpers';
import { CurrentTeamContext } from '../../../contexts/CurrentTeamContext';
import sortOptions from '../../Options/sortOptions';

export default function OrdersFilterBar(props) {
	const { filter, handleFilter, handleSearch, openFilter, handleFilterSelect } = props || {};

	const { teamState } = useContext(CurrentTeamContext);

	function parseStatusesCsv(val) {
		if (!val) return [];
		return String(val)
			.split(',')
			.map((s) => s.trim())
			.filter(Boolean);
	}

	const statusesArr = parseStatusesCsv(filter?.statuses);
	const dropdownValue = statusesArr.length === 1 ? statusesArr[0] : 'all';

	return (
		<div className='filterBar'>
			<div className='field'>
				<h4 className='label'>Search for order</h4>
				<input
					className='textFieldInput'
					onChange={(e) => {
						handleSearch(e.target.value);
					}}
				/>
			</div>
			<div className='field'>
				<h4 className='label'>Status</h4>
				<SelectCustom
					htmlOptions={[
						<option key='all' value='all'>
							All
						</option>,
						<option key='0' value='0'>
							Draft
						</option>,
						<option key='1' value='1'>
							Pending
						</option>,
						<option key='2' value='2'>
							Accepted
						</option>,
						<option key='3' value='3'>
							Processing
						</option>,
						<option key='4' value='4'>
							Completed
						</option>,
						<option key='5' value='5'>
							Dispatched
						</option>,
						<option key='6' value='6'>
							Delivered
						</option>,
						<option key='7' value='7'>
							Disputed
						</option>,
						<option key='8' value='8'>
							Void
						</option>,
						<option key='9' value='9'>
							Rejected
						</option>,
					]}
					fieldName='status'
					callback={(e) => {
						const v = e.value;
						if (v === 'all') {
							handleFilter(null); // triggers reset in your handler
							return;
						}
						// set single status as statuses="X"
						handleFilter(String(v), 'statuses');
					}}
					placeholder={'Select...'}
					value={dropdownValue}
					width={300}
				/>
			</div>
			<div className='field'>
				<h4 className='label'>Due date</h4>
				<SelectCustom
					htmlOptions={sortOptions}
					placeholder={'Select...'}
					fieldName='sort'
					callback={handleFilterSelect}
					value={filter?.sort}
					width={300}
				/>
			</div>
			<div className='field disabledDiv'>
				<h4 className='label'>Buyer</h4>
				<SelectCustom
					options={[
						{ name: 'All', value: undefined },
						...parseToOptions(teamState?.currentTeam?.members, 'members'),
					]}
					placeholder={'Select...'}
					fieldName='buyer'
					callback={handleFilterSelect}
					value={filter?.buyer}
					width={300}
				/>
			</div>
			<Button
				text='All filters'
				size='md'
				style='secondary'
				iconRight={<ArrowNarrowRightIcon />}
				onClick={openFilter}
			/>
		</div>
	);
}
